import { Check } from "lucide-react";

import { cn } from "@/shared/lib/cn";

import { answered, type AskQuestion } from "../askUser";
import type { QuestionPicks } from "../hooks/useQuestionPicks";

/* The questions a run asks as steps on ComposerDock's strip, the Stepper Form's head: the one
   open in ink, answered ones checked and a click away, the rest ahead. A phone shows where the
   person is instead ("2 of 3 · Channels"). */
export default function QuestionSteps({ questions, picks }: { questions: AskQuestion[]; picks: QuestionPicks }) {
  const { page } = picks;
  return (
    <div className="flex-1 min-w-0 flex items-center justify-end gap-0.5 overflow-hidden">
      {questions.map((question, i) => {
        const done = i !== page && answered(picks.picks[i]);
        return (
          <button
            key={question.question}
            type="button"
            onClick={() => picks.go(i)}
            disabled={i !== page && !done}
            aria-current={i === page ? "step" : undefined}
            className={cn(
              "hidden sm:inline-flex items-center gap-[5px] h-[26px] min-w-0 px-[7px] rounded-[8px] text-[12px] whitespace-nowrap transition-colors duration-150",
              i === page ? "font-medium text-[var(--text-primary)]" : done ? "text-[var(--text-secondary)] hover:bg-[var(--accent-active)] hover:text-[var(--text-primary)]" : "text-[var(--text-quaternary)]",
            )}
          >
            {done ? <Check className="w-3 h-3" strokeWidth={2.4} /> : <span className="tabular-nums">{i + 1}.</span>}
            <span className="truncate">{question.header || `Question ${i + 1}`}</span>
          </button>
        );
      })}
      <span className="sm:hidden px-2 text-[12px] text-[var(--text-tertiary)] tabular-nums truncate">
        {page + 1} of {questions.length} · {questions[page].header || "Questions"}
      </span>
    </div>
  );
}
